export const USER_INITIALISED = 'user:initialised'
export const USER_LOGIN = 'user:login'
